import { render } from "./BimPlusViewer.vue?vue&type=template&id=a2adad1c&scoped=true"
import script from "./BimPlusViewer.vue?vue&type=script&lang=js"
export * from "./BimPlusViewer.vue?vue&type=script&lang=js"

import "./BimPlusViewer.vue?vue&type=style&index=0&id=a2adad1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2adad1c"]])

export default __exports__